// @ts-check
import {
  SET_COSTS,
  SET_CURRENCY
} from '../../../redux/actions/actionTypes';

const initialState = {
  demolition: 200000,
  site_preparation: 100000,
  infrastructure: 250000,
  excavation: 200000,
  pre_construction_other: 0,
  architect: 5,
  quantity_surveyor: 1,
  structural_engineer: 1,
  mechanical_engineer: 1,
  project_manager: 3,
  licensing: 6,
  marketing: 1,
  soft_other: 0,
  currency: '$'
}

function formCostsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_COSTS:
      return {
        ...state,
        [action.payload.field]: action.payload.value
      }
    case SET_CURRENCY:
      console.log('-------------set Currency---------------------')
      return {
        ...state,
        currency: action.payload
      }

    default:
      return state;
  }
}

export default formCostsReducer